import styled from "@emotion/styled";

import stotlesLogo from "../../../assets/images/stotles_logo_and_typeface.svg";

// `authPageStyles`' Card (and the sign-up form column) style every descendant anchor as an inline text
// link — underlined, in brand blue. That descendant selector outweighs a plain class, hence `&&` to
// double this one's specificity: the lockup is an image, not a run of text.
const LogoLink = styled.a({
  "&&": {
    display: "flex",
    alignSelf: "flex-start",
    textDecoration: "none",
  },
});

const Logo = styled.img({
  height: 32,
  width: "auto",
  display: "block",
});

/**
 * The Stotles lockup, and the only way off a pre-login page — these screens render bare, with no header
 * to escape through, so the logo carries the link out to the marketing site (the same thing
 * HorizontalNav's logo does for the rest of the app).
 */
export function StotlesLogo() {
  return (
    <LogoLink href="https://www.stotles.com">
      <Logo src={stotlesLogo} alt="Stotles" />
    </LogoLink>
  );
}
